import { defineComponent as _defineComponent } from 'vue'
import { getCountries, getCountryCallingCode, isPossiblePhoneNumber, isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js'
import type { CountryCode } from 'libphonenumber-js'
import { computed, ref, watch, onMounted } from 'vue';

type Props = {
    modelValue: string | null,
    label: string | null,
}
type Emits = {
    (e: 'update:modelValue', number: string | null): void
    (e: 'submit'): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'phone-input',
  props: {
    modelValue: null,
    label: null
  },
  emits: ["update:modelValue", "submit"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: 'update:modelValue', number: string | null): void
    (e: 'submit'): void
}), expose: any, slots: any, attrs: any }) {
  expose();

const props = __props as {
    modelValue: string | null,
    label: string | null,
}

/// -- This component acts like a regular text input, however, it'll automatically validate
// the phone input. If it's not valid, the v-model value will be null.



const codeList = computed<CountryCode[]>(() => getCountries());

const numberInput = ref('');
const countryCode = ref<CountryCode>('US');
const isValid = ref(false);

const handleKey = (e: KeyboardEvent) => {
    if(e.key === 'Enter') {
        emit('submit');
    }
}

watch(numberInput, val => {
    if(isPossiblePhoneNumber(val, countryCode.value)) {
        const phoneNumber = parsePhoneNumber(val, countryCode.value);
        if(countryCode.value !== phoneNumber.country) countryCode.value = phoneNumber.country || 'US';
        isValid.value = true;
        emit('update:modelValue', phoneNumber.number);
    } else {
        isValid.value = false;
        emit('update:modelValue', null);
    }
})

onMounted(() => {
    if(props.modelValue)
        numberInput.value = props.modelValue
})

watch(() => props.modelValue, val => {
    if(val) numberInput.value = val
})


const __returned__ = { props, emit, codeList, numberInput, countryCode, isValid, handleKey, getCountries, getCountryCallingCode, isPossiblePhoneNumber, isValidPhoneNumber, parsePhoneNumber, computed, ref, watch, onMounted }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})